module.exports = __webpack_public_path__ + "static/media/blue.529481e6.png";